import React from "react";
import { ToyLinksData } from "../assets/data/ToyLinksData";

const DarazToys = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6 mt-36">
      <h1 className="text-3xl font-bold text-center mb-8">Daraz Toys Collection</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {ToyLinksData.map((toy, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-md overflow-hidden p-4 flex flex-col items-center">
            <img src={toy.image} alt={toy.title} className="h-64 object-contain mb-4" />
            <h2 className="text-xl font-semibold mb-2 text-center">{toy.title}</h2>
            <a
              href={toy.link}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto inline-block px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
            >
              Click Here to Open Link
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DarazToys;
